module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"components":{"users":{"profile":{"advisory_services":{"action":"Schwerpunkte auswählen","empty_state":"Wählen Sie die Beratungsschwerpunkte aus, die Sie anbieten. So wissen Interessenten, dass sie Sie kontaktieren können.<br/><br/> Achtung: Um von anderen gefunden zu werden, müssen Sie mindestens einen Schwerpunkt wählen!","title":"Beratungsschwerpunkte"}}}}}}}')
  delete Component.options._Ctor
}
